import React, { useState } from 'react';
import { SearchType } from 'utils/types';
import AddonCategoryCard from 'components/addon-category-card';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import {
  Dropdown,
  DropdownItem,
  DropdownList,
  ToastMessage
} from '@cokitchen/cokitchen-components';
import DeleteModal from 'components/base/delete-modal';
import { ReactComponent as EditMealIcon } from 'assets/icons/edit-meal-icon.svg';

import { ReactComponent as DeleteMealIcon } from 'assets/icons/delete-meal-icon.svg';
import EditAddonModal from 'components/edit-addon-modal';
import { MenuHorizontalIcon } from 'cokitchen-icons';
import { ReactComponent as RestoreIcon } from 'assets/icons/restore.svg';
import useDashboardContext from 'contexts/dashboard.context';

type AddnSearchResultsProps = {
  selectedResults: SearchType[];
  search: SearchType;
  handleChange: (result: SearchType) => void;
};
const AddonSearchResults = ({
  selectedResults,
  handleChange,
  search: searchData
}: AddnSearchResultsProps) => {
  const [search, setSearch] = useState(searchData);
  const [loading, setLoading] = useState(false);
  const [showEditMealCategoryModal, setShowEditMealCategoryModal] = useState(false);
  const [showDeleteMealCategoryModal, setShowDeleteMealCategoryModal] = useState(false);
  const [showRestoreModal, setShowRestoreModal] = useState(false);
  const editMealCategory = () => {
    setShowEditMealCategoryModal(!showEditMealCategoryModal);
  };
  const { trash } = useDashboardContext();

  const restoreModal = () => {
    setShowRestoreModal(!showRestoreModal);
  };
  const handleDeleteClick = async () => {
    try {
      setLoading(true);
      const res = await apiService.post('marketting/delete-addon/bulk', {
        data: {
          addon_ids: [search.id]
        }
      });

      const { message } = res.data;

      toast(<ToastMessage type='success' message={message} />);
      setShowDeleteMealCategoryModal(false);
    } catch {
      toast(<ToastMessage type='error' message='Error occur while deleting item' />);
    } finally {
      setLoading(false);
    }
  };
  const deleteMealCategory = () => {
    setShowDeleteMealCategoryModal(!showDeleteMealCategoryModal);
  };

  const options = [
    { onClick: editMealCategory, name: 'Edit add-on', icon: <EditMealIcon /> },
    {
      onClick: deleteMealCategory,
      name: 'Archive add-on',
      icon: <DeleteMealIcon />,
      className: 'text-[#E60A2B]'
    }
  ];
  const handleRestoreClick = async () => {
    const itemIds = selectedResults.length > 0 ? selectedResults : [search.id];
    const payload = { type: 'addon', item_ids: itemIds };
    try {
      const res: any = await apiService.post('marketing/restore-bulk-items', { data: payload });
      if (res.data) {
        setShowRestoreModal(false);
        toast(
          <ToastMessage
            type='success'
            message={`Restored ${search.name || 'items'} successfully `}
          />
        );
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err?.response.data.message} />);
    }
  };
  return (
    <div>
      <AddonCategoryCard
        checked={selectedResults.includes(search)}
        selectedItems={selectedResults}
        onChange={() => handleChange(search)}
        key={search?.id}
        data={search}
        showCheckbox
        actions={
          !trash ? (
            <Dropdown
              className='right-4'
              content={
                <MenuHorizontalIcon
                  className={`cursor-pointer w-[22px] h-[22px] text-white bg-black hover:bg-black opacity-20 rounded p-[3px] transition-none z-10`}
                />
              }>
              <DropdownList>
                {options.map(({ icon, onClick, name, className }, index) => (
                  <DropdownItem
                    key={index}
                    onClick={onClick}
                    className='text-sm font-light  hover:bg-gray-400 cursor-pointer'
                    buttonClassName='p-2'>
                    <div className='flex justify-start gap-3 items-center'>
                      <div className='list-icon rounded-full p-1  border-[0.6px]  border-[#EAEAEB]'>
                        {icon}
                      </div>
                      <p className={`${className}`}>{name}</p>
                    </div>
                  </DropdownItem>
                ))}
              </DropdownList>
            </Dropdown>
          ) : (
            <RestoreIcon
              className='cursor-pointer'
              onClick={() => {
                setShowRestoreModal(!showRestoreModal);
              }}
            />
          )
        }
      />
      <DeleteModal
        show={showDeleteMealCategoryModal}
        onClose={deleteMealCategory}
        handleDelete={() => handleDeleteClick()}
        title={`Are you sure you want to delete ${search?.name} ?`}
        description='This action cannot be undone'
        loading={loading}
      />
      <EditAddonModal
        show={showEditMealCategoryModal}
        onClose={(data) => {
          editMealCategory();
          if (data) {
            setSearch((s) => ({
              ...s,
              name: data?.name,
              amount: data?.amount ?? ''
            }));
          }
        }}
        data={{
          name: search?.name,
          addon_ids: search?.id,
          amount: search?.amount ?? '',
          addon_meal_id: search?.addon_meal_id ?? ''
        }}
      />
      <DeleteModal
        show={showRestoreModal}
        type='restore'
        onClose={restoreModal}
        handleDelete={handleRestoreClick}
        title={`Are you sure you want to restore ${
          selectedResults.length > 0 ? 'items' : search?.name
        } `}
        description='This action will restore this addon'
        loading={loading}
      />
    </div>
  );
};

export default AddonSearchResults;
